module.exports = __webpack_public_path__ + "static/media/queens-university.f77e2242.png";